// extracted by mini-css-extract-plugin
module.exports = {"title":"line-item-module--title--z3zg7","variant":"line-item-module--variant--1XJ56","totals":"line-item-module--totals--3yIye"};